export const FACULTIES = [
  "文系全般/学部未定",
  "理系全般/学部未定",
  "文学部",
  "法学部",
  "経済学部",
  "経営学部",
  "商学部",
  "社会学部",
  "教育学部",
  "国際学部",
  "外国語学部",
  "心理学部",
  "文系（その他）",
  "理学部",
  "工学部",
  "情報学部",
  "農学部",
  "生命科学部",
  "医・歯・薬・看護など医療系",
  "理系（その他）",
  "芸術系学部（デザイン分野）",
  "芸術系学部（音楽分野）",
  "スポーツ系学部",
  "その他",
];
